export default {
    spacing: 20,
    sidebar: {
        width: 270,
    },
}
